import { IncludedItemData } from "../types";

export const IncludedItem = ({ item }: { item: IncludedItemData }) => {
  return (
    <div className="included-item">
      <span className="included-check" aria-hidden="true">
        <svg viewBox="0 0 12 12" fill="none" stroke="white" strokeWidth="2">
          <path d="M2 6l2.5 2.5L10 3" />
        </svg>
      </span>
      <div className="included-item-text">
        <strong>{item.title}</strong>
        <span>{item.description}</span>
      </div>
    </div>
  );
};
